<template>
  <layout>
    <!--城市选择区-->
    <template v-slot:pageLeft>
      <QHleftcity @change="change" ref="QHleftcity"></QHleftcity>
    </template>
    <!--城市选择区 end-->

    <!--总统计区-->
    <template v-slot:pageTab>
      <div class="headerA flex-center">
        <div class="flex-center-col">
          <font class="fontColor">排放单位</font>
          <span v-if="scene == 'sceneUsed'">已开通</span>
          <span v-if="scene == 'sceneGov'">监管审核</span>
        </div>
      </div>
      <div class="headerB flex-between">
        <div class="flex-center-y">
          <dl class="item" @click="searchGovAuthStatus()">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">
                <p>{{ dataName }}</p>
                <p>单位数量</p>
              </div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(total.count || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">家</div>
            </dt>
          </dl>

          <!--场景：政府审核-->
          <template v-if="scene == 'sceneGov'">
            <dl class="item" @click="searchGovAuthStatus(100)">
              <dt class="bigNumber flex-center-y">
                <div class="danwei">
                  <p>监管方</p>
                  <p class="flex-center-y">
                    <span class="icon iconfont icon-gongzuoshijian flex-center icon100"></span>
                    <span>待审</span>
                  </p>
                </div>
                <div class="num flex-center">
                  <span v-for="(item, index) in $numToArr(total.govAuthStatus100 || 0)" :key="index">
                    <font>{{ item }}</font>
                  </span>
                </div>
                <div class="danwei">家</div>
              </dt>
            </dl>
            <dl class="item" @click="searchGovAuthStatus(200)">
              <dt class="bigNumber flex-center-y">
                <div class="danwei">
                  <p>监管方</p>
                  <p class="flex-center-y">
                    <span class="icon iconfont icon-yunshuwancheng flex-center icon200"></span>
                    <span>通过</span>
                  </p>
                </div>
                <div class="num flex-center">
                  <span v-for="(item, index) in $numToArr(total.govAuthStatus200 || 0)" :key="index">
                    <font>{{ item }}</font>
                  </span>
                </div>
                <div class="danwei">家</div>
              </dt>
            </dl>
            <dl class="item" @click="searchGovAuthStatus(300)">
              <dt class="bigNumber flex-center-y">
                <div class="danwei">
                  <p>监管方</p>
                  <p class="flex-center-y">
                    <span class="icon iconfont icon-jujue flex-center icon300"></span>
                    <span>拒审</span>
                  </p>
                </div>
                <div class="num flex-center">
                  <span v-for="(item, index) in $numToArr(total.govAuthStatus300 || 0)" :key="index">
                    <font>{{ item }}</font>
                  </span>
                </div>
                <div class="danwei">家</div>
              </dt>
            </dl>

            <dl class="item" @click="$QHopen.url('/log?action=200',95,95)" v-if="!$isblank(logTotast)">
              <dt class="bigNumber flex-center-y">
                <div class="danwei">
                  <p>审核</p>
                  <p class="flex-center-y">
                    <span>记录</span>
                  </p>
                </div>
                <div class="num flex-center">
                  <span v-for="(item, index) in $numToArr(logTotast.action_200 || 0)" :key="index">
                    <font>{{ item }}</font>
                  </span>
                </div>
                <div class="danwei">次</div>
              </dt>
            </dl>
          </template>
          <!--场景：政府审核 end-->
        </div>
      </div>
    </template>
    <!--总统计区 end-->

    <!--搜索及功能区-->
    <template v-slot:pageSearch>
      <ul class="tab">
        <li>
          <Select v-model="searchMap.orgKind" @on-change="search" slot="prepend" style="width: 160px" placeholder="不限">
            <span slot="prefix">单位类型</span>
            <Option value="">不限</Option>
            <Option :value="index" v-for="(item, index) in $CLIST['orgKind']" :key="index">{{ item }}</Option>
          </Select>
        </li>

        <li>
          <Select v-model="searchMap.hasPaifang" @on-change="search" slot="prepend" style="width: 120px" placeholder="不限">
            <span slot="prefix">有排放</span>
            <Option value="">不限</Option>
            <Option value="1">是</Option>
            <Option value="-1">否</Option>
          </Select>
        </li>
        <li>
          <Select v-model="searchMap.hasProject" @on-change="search" slot="prepend" style="width: 120px" placeholder="不限">
            <span slot="prefix">有项目</span>
            <Option value="">不限</Option>
            <Option value="1">是</Option>
            <Option value="-1">否</Option>
          </Select>
        </li>
        <li>
          <Select v-model="searchMap.paifangAuth" @on-change="search" slot="prepend" style="width: 120px" placeholder="不限">
            <span slot="prefix">开通</span>
            <Option value="">不限</Option>
            <Option :value="index" v-for="(item, index) in $CLIST['paifangAuth']" :key="index">{{ item }}</Option>
          </Select>
        </li>
        <li>
          <Select v-model="searchMap.govAuthStatus" @on-change="search" slot="prepend" style="width: 120px" placeholder="不限">
            <span slot="prefix">监管</span>
            <Option value="">不限</Option>
            <Option :value="index" v-for="(item, index) in $CLIST['govPaifangAuthStatus']" :key="index">{{ item }}</Option>
          </Select>
        </li>
        <li style="width: 280px">
          <Input size="small" v-model="searchMap.keywordA" placeholder="请输入关键词">
            <Select v-model="searchMap.likeNameA" slot="prepend" style="width: 90px">
              <Option value="name">单位名称</Option>
              <Option value="addressFull">所在地区</Option>
            </Select>
          </Input>
        </li>
        <li>
          <Button type="warning" size="small" @click="search">查询</Button>
        </li>
        <li>
          <Button type="primary" @click="uploadExcel" size="small">导出</Button>
        </li>
      </ul>
    </template>
    <!--搜索及功能区 end-->

    <!--主体呈现区-->
    <template v-slot:pageContent>
      <div class="REWwater" v-if="scene == 'sceneUsed'">已开通排放单位</div>
      <div class="REWwater" v-if="scene == 'sceneGov'">监管审核排放单位</div>
      <QHTable :total="total['pageCount'] || 0" :pageThis="pageThis">
        <Table :columns="columns" :data="list" @on-selection-change="(event) => $tableSeletChange(event, pageThis)" :loading="loading" class="QHTableList">
          <!--分割区-->
          <template slot-scope="{ row }" slot="name">
            <span>{{ row.name }}</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="orgKind">
            <span>{{ $CVALUE("orgKind", row.orgKind) }}</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="paifangAuth">
            <span>{{ $CVALUE("paifangAuth", row.paifangAuth) }}</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="name">
            <span class="FTC4 oe1" style="font-size: 17px; font-weight: 700">{{ row.name }}</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="paifangProjectTotal">
            <span>{{ row.paifangProjectTotal }}个</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="paifangGarbageNumberTotal">
            <span>{{ row.paifangGarbageNumberTotal }}m³</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="paifangGarbageCountTotal">
            <span>{{ row.paifangGarbageCountTotal }}次</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="allQualificationsCount">
            <b style="font-size: 18px; color: #01aaed" v-if="row.allQualificationsCount > 0">{{ row.allQualificationsCount }}</b>
            <b style="font-size: 18px; color: #bbb" v-if="row.allQualificationsCount == 0">{{ row.allQualificationsCount }}</b>
            <span>件</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="invalidQualificationsCount">
            <b style="font-size: 18px; color: #ed4014" v-if="row.invalidQualificationsCount > 0">{{ row.invalidQualificationsCount }}</b>
            <b style="font-size: 18px; color: #bbb" v-if="row.invalidQualificationsCount == 0">{{ row.invalidQualificationsCount }}</b>
            <span>件</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="decryptToId">
            <span> {{ $decryptToId(row.id) }}</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="govAuthStatus">
            <Tag :color="$CVALUE('govAuthStatusTagColor', row.govAuthStatus)">{{ $CVALUE("govAuthStatus", row.govAuthStatus) }}</Tag>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="action">
            <Button size="small" @click="$goOrgPaifangElectronicbillList(row)" type="success" >联单</Button>
            <Button v-if="scene == 'sceneUsed'" type="warning" size="small" @click="$refs.detailed.hiPop(row)" style="margin-left: 5px">详情</Button>
            <Button v-if="scene == 'sceneGov'" type="warning" size="small" @click="$refs.detailed.hiPop(row)" style="margin-left: 5px">监管</Button>
          </template>
        </Table>
      </QHTable>
    </template>
    <!--主体呈现区 end-->

    <!--弹窗组件区-->
    <template v-slot:pageBlock>
      <QHexcelDownload ref="QHexcelDownload"></QHexcelDownload>
      <detailed ref="detailed" @success="getList();$getLogTotast();" :scene="scene"></detailed>
    </template>
    <!--弹窗组件区 end-->
  </layout>
</template>
<script>
import detailed from "./block/detailed/detailed";
import QHexcelDownload from "@/layout/component/QHexcelDownload/QHexcelDownload";
export default {
  components: {
    detailed,
    QHexcelDownload,
  },
  data() {
    return {
      //列表配置项(loading加载效果,columns列,list数据,selectedRows选中,total统计项)@@@@@@@@@@@
      list: [],
      loading: false,
      pageThis: this,
      selectedRows: [],
      total: {},
      selectedRowsMore: [],
      columns: this.$colFilter([
         {
          type: "selection",
          width: 40,
          align: "center",
        },
        {
          title: "排放单位",
          key: "name",
          minWidth: 400,
          slot: "name",
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "单位类型",
          slot: "orgKind",
          width: 80,
          align: "center",
        },
        {
          title: "开通状态",
          slot: "paifangAuth",
          width: 80,
          align: "center",
        },
        {
          title: "创建项目",
          slot: "paifangProjectTotal",
          width: 80,
          align: "center",
        },
        {
          title: "排放总方",
          slot: "paifangGarbageNumberTotal",
          width: 80,
          align: "center",
        },
        {
          title: "排放运次",
          slot: "paifangGarbageCountTotal",
          width: 80,
          align: "center",
        },
        {
          title: "所属城市",
          key: "cityName",
          width: 120,
          align: "center",
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "所属区县",
          key: "districtName",
          align: "center",
          width: 100,
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "所属街道",
          key: "streetName",
          align: "center",
          width: 100,
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "详细地址",
          key: "addressFull",
          align: "center",
          width: 100,
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "联系姓名",
          key: "contactName",
          width: 100,
          align: "center",
        },
        {
          title: "联系电话",
          key: "contactTel",
          width: 110,
          align: "center",
        },
        {
          title: "全部资质",
          width: 80,
          align: "center",
          slot: "allQualificationsCount",
        },
        {
          title: "异常资质",
          width: 80,
          align: "center",
          slot: "invalidQualificationsCount",
        },
        {
          title: "联单查询码",
          key: "decryptToId",
          width: 100,
          align: "center",
          slot: "decryptToId",
        },
        {
          title: "开通时间",
          key: "created",
          width: 135,
          align: "center",
          render: (h, parameter) => {
            var row = parameter.row;
            let time = this.$timeFmt(row.created, "YYYY-MM-DD HH:mm");
            return h("span", time);
          },
        },
        {
          title: "监管状态",
          width: 80,
          align: "center",
          slot: "govAuthStatus",
          fixed: "right",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          width: 110,
          slot: "action",
          align: "center",
        },
      ]),

      //搜索配置项@@@@@@@@@@@@@@@@@@@@@@@
      searchMap: {
        likeNameA: "name",
        keywordA: "",
        paifangAuth: "",
        govAuthStatus: "",
        orgKind: "",
        hasPaifang: "",
        hasProject: "",
        pageNo: 1,
        pageSize: 25,
      },
      searchMapInt: {},
      total: {},
      //其他逻辑配置项@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
      dataLoading: false,
      dataName: "",
      scene: "",
      logTotast:{},
    };
  },

  // +----------------------------------------------------------------------
  // | mounted
  // +----------------------------------------------------------------------
  mounted() {
    //获取场景
    var scene = this.$getUrlParams("scene");
    this.scene = scene || "sceneUsed";

    //非政府场景
    if (this.scene == "sceneUsed") {
      this.searchMap.paifangAuth = "100";
    }

    //政府监管
    if (this.scene == "sceneGov") {
      this.searchMap.paifangAuth = "100";
    }
    this.searchMapInt = this.$copyObj(this.searchMap);
    this.$refs.QHleftcity.int();

    //审核日志
    this.$getLogTotast();
  },

  methods: {
    // +----------------------------------------------------------------------
    // | 切换数据地址数据
    // +----------------------------------------------------------------------
    change(res) {
      this.searchMap = this.$copyObj(this.searchMapInt);
      this.searchMap.code = res.code;
      this.searchMap.level = res.level;
      this.dataName = res.name;
      this.dataLoading = false;
      this.getList();
    },

    // +----------------------------------------------------------------------
    // | 列表
    // +----------------------------------------------------------------------
    getList() {
      var that = this;
      this.searchMap = this.$trimObjectSpaces(this.searchMap);
      var https = {
        type: "isPagelist",
        api: this.$api.getOrgpaifangList,
        parameter: this.searchMap,
      };
      this.$httpsApi(https, function () {
        that.dataLoading = true;
      });
    },

    // +----------------------------------------------------------------------
    // | 导出excel
    // +----------------------------------------------------------------------
    uploadExcel() {
      var that = this;
      if (this.scene == "sceneUsed") {
        var title = "红白蓝平台已开通排放单位";
      }
      if (this.scene == "sceneGov") {
        var title = "红白蓝平台监管审核排放单位";
      }
      this.searchMap = this.$trimObjectSpaces(this.searchMap);
      var searchMap=this.$copyObj(this.searchMap);
      searchMap['ids']=this.$copyObj(this.selectedRows);
      this.$refs.QHexcelDownload.hiPop({
        title: title,
        api: that.$api.getOrgpaifangExcelList,
        searchMap: searchMap,
        columns: this.$ExcelDownloadConfig["headOrgPaifang"],
      });
    },

    // +----------------------------------------------------------------------
    // | 执行govAuthStatus搜索请求
    // +----------------------------------------------------------------------
    searchGovAuthStatus(govAuthStatus) {
      this.searchMap.govAuthStatus = govAuthStatus;
      this.search();
    },

    // +----------------------------------------------------------------------
    // | 搜索
    // +----------------------------------------------------------------------
    search() {
      this.searchMap.pageNo = 1;
      this.getList();
    },
  },
};
</script>
